import {RecursosController} from "../recursos";

declare global {
    interface Window {
        _nat: any,
        NATIVERY: any,
    }
}

export class NativosController extends RecursosController {

    /* INSTANCE */
    public static instance: NativosController;
    private readonly id_noticia: number;

    /* STATIC */
    public static override async build(id_noticia: number = 0): Promise<void> {
        NativosController.instance = new this(id_noticia);
        RecursosController.instances.push(NativosController.instance);
    }

    private constructor(id_noticia: number) {
        super();
        this.id_noticia = id_noticia;
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const nativeryId = 'publicidad-nativery' + ((this.id_noticia > 0) ? ("-" + this.id_noticia) : "");

        const resources = Array.from(html.querySelectorAll(`[id*=${nativeryId}]`));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement) : Promise<void> {
        let nodes = await this.getNativeryNode();
        for (let node of nodes) item.appendChild(node);
        if (item.id.includes('nativery')) await this.loadNativeryScript();
    }

    private async getNativeryNode(): Promise<HTMLElement[]> {
        const nodes: HTMLElement[] = [];
        const div = document.createElement("div");
        const id = this.getNativeryID();
        div.id = "nat_" + id;
        nodes.push(div);
        return nodes;
    }

    private getNativeryID() : string {
        return window.device === 'mv'? "66194d2088a6e57292541de0" : "65141c6197e69f1562ed88fb";
    }

    private async loadNativeryScript(): Promise<void> {
        const id = this.getNativeryID();
        if (!window._nat) {
            window._nat = window._nat || [];
            window._nat.push(['id', id, {infinite: true}]);
        }

        if (document.getElementById("nativery")) {
            window.NATIVERY.push(id, {infinite: true});
        } else {
            const nat = document.createElement('script');
            nat.id = "nativery";
            nat.type = 'text/javascript';
            nat.async = true;
            nat.src = '//cdn.nativery.com/widget/js/nat.js';
            const nats = document.getElementsByTagName('script')[0];
            nats.parentNode?.insertBefore(nat, nats);
        }
    }

}
